import NoResults from 'components/general/noResults';
import { taskRating } from 'components/tasks/taskList';
import { ArrayHelpers, Help, Loading, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGet } from 'services';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, differenceInCalendarDays } from 'helpers/dates';

export const TeamTasks = ({ profileId, range, offset, filter }) => {
    const [tasks, setTasks] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        setLoading(true);
        apiGet(
            `team-performance-objectives/${profileId}?filter=${filter}&offset=${offset}&range=${range}`,
            user.guid,
            response => {
                setTasks(response);
                setLoading(false);
            }
        );
    }, [profileId, range, offset, filter]);

    if (loading) return <Loading />;

    return (
        <div>
            {ArrayHelpers.existsAndHasLength(tasks) ? (
                tasks.map(task => {
                    const completedDaysLate = task.date_Completed
                        ? differenceInCalendarDays(task.due, task.date_Completed)
                        : 0;
                    const daysPastDue = task.due ? differenceInCalendarDays(task.due, new Date()) : 0;

                    return (
                        <div className="mb10" key={`task-${task.id}`}>
                            <div>
                                <Link to={`/objectives/${task.profile_Id}/objective/${task.id}`}>
                                    {task.name}
                                    <TaskIcon icons={task.icons} />
                                    {task.description && <Help id={`row_${task.id}`}>{task.description}</Help>}
                                </Link>
                            </div>
                            {task.assigned_Id !== profileId && (
                                <div>
                                    <i className="fa fa-user mr5" />
                                    {task.assigned_Fullname}
                                </div>
                            )}
                            <div>
                                <i className="fa fa-calendar mr5" />
                                {SystemText('Tasks/TaskList/Summary/Due')}
                                {': '}
                                {task.due ? e4Format(task.due) : '-'}
                            </div>
                            <div>
                                <i className="fa fa-calendar mr5" />
                                {SystemText('Tasks/TaskList/Summary/Completed')}
                                {': '}
                                {task.date_Completed ? e4Format(task.date_Completed) : '-'}
                            </div>
                            <div className="mt5">
                                <span className="flex flex-center">
                                    {task.metric_Task && !task.goal_Met ? (
                                        <span className="p5 ml10 hidden-xs hidden-sm hidden-md label label-danger">
                                            <i className="fa fa-times fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/NotAchieved')}</span>
                                        </span>
                                    ) : !task.date_Completed && daysPastDue < 0 ? (
                                        <span className="p5 hidden-xs hidden-sm hidden-md label label-danger">
                                            <i className="fa fa-warning fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/Overdue')}</span>
                                        </span>
                                    ) : !task.date_Completed > 0 ? (
                                        <span className="p5 hidden-xs hidden-sm hidden-md label label-warning">
                                            <i className="fa fa-warning fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/Outstanding')}</span>
                                        </span>
                                    ) : completedDaysLate > 0 ? (
                                        <span className="p5 hidden-xs hidden-sm hidden-md label label-danger">
                                            <i className="fa fa-warning fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/Late')}</span>
                                        </span>
                                    ) : (
                                        <span className="p5 hidden-xs hidden-sm hidden-md label label-success">
                                            <i className="fa fa-thumbs-up fa-green mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/OnTime')}</span>
                                        </span>
                                    )}
                                    {task.date_Completed && task.requires_Manager && !task.date_Approved && (
                                        <span className="p5 hidden-xs hidden-sm hidden-md label label-warning ml5">
                                            <i className="fa fa-stamp fa-green mr5" />
                                            <span>{SystemText('Tasks/TaskList/Status/AwaitingApproval')}</span>
                                        </span>
                                    )}
                                </span>
                            </div>
                            <div className="mt5">{taskRating(task, null, true)}</div>
                        </div>
                    );
                })
            ) : (
                <NoResults
                    title={SystemText('Tasks/TaskList/Summary/NoResults/Title')}
                    message={SystemText('Tasks/TaskList/Summary/NoResults/Message')}
                />
            )}
        </div>
    );
};

export default TeamTasks;
